'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { StoryService } from '@/contexts/stories/services/StoryService';
import { EDIT_FORBIDDEN, guardEdit } from '@/contexts/pipeline-v2/edits/guardAction.server';
import type { Story } from '@/contexts/stories/types/story';

export async function updateStory(
  storyId: string,
  updates: Record<string, any>,
): Promise<ActionResult<Story>> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    // the title and the dedication are edits after ready: they wait for the generation
    const kind = 'title' in updates ? 'title' : 'dedication' in updates ? 'dedication' : null;
    if (kind) {
      const blocked = await guardEdit({ storyId, kind });
      if (blocked) return { success: false, error: blocked.message, code: EDIT_FORBIDDEN };
    }

    const story = await StoryService.updateStory({
      storyId,
      familyId,
      updates,
    });

    return { success: true, data: story as unknown as Story };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('updateStory', e) };
  }
}
